import { routeList } from '@/router/helpers/routes'

export default [{
	path: routeList.MY_AGENCY_PATH,
	name: routeList.MY_AGENCY_NAME,
	component: () => import('@/views/MyAgency')
}]
